import { render } from "./SubMenu0.vue?vue&type=template&id=e60c3520&scoped=true"
import script from "./SubMenu0.vue?vue&type=script&lang=js"
export * from "./SubMenu0.vue?vue&type=script&lang=js"

import "./SubMenu0.vue?vue&type=style&index=0&id=e60c3520&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60c3520"]])

export default __exports__